/** @module Specification/BOMLanguageMatrix */
define([
	"dojo/_base/declare",
	"csi/table/matrix/ColumnMap",
	"csi/xml"
], function(declare, ColumnMap, xml) {

	return declare(ColumnMap, {
		hideLoneSubheader: true,

		/**
		 * Add DependencyPath for BOMLanguages
		 */
		addDependencyPaths: function(h, paths) {
			paths.push(xml.path("BOMLanguages"));
		},

		/**
		 * If view has active languages, then only return subset of all languages
		 */
		_getColumnNodes: function(ctx, h) {
			return ctx.cache.getNodes(ctx.getParent().BOMLanguages);
		}
	});
});
